export default {
	"ADD_PAGE_ONE": "ADD_PAGE_ONE",
	"ADD_PAGE_TWO": "ADD_PAGE_TWO",
	"ADD_PAGE_THREE": "ADD_PAGE_THREE",
	"ADD_PAGE_FOUR": "ADD_PAGE_FOUR",
	"CALCULATE_RISK": "CALCULATE_RISK",
}